import reqwest from 'reqwest';
import { generatorAuth } from 'src/tools/helper';

class Reqwest {
  on(props: any) {
    const auth = generatorAuth();
    reqwest({
      headers: {
        Authorization: auth,
      },
      ...props,
    });
  }
}
const _req = new Reqwest();
export default _req;
